import React from 'react';
import { Icon } from './Icon.js';
export const IconPhoneModernFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M12.25,1H5.75c-.965,0-1.75,.785-1.75,1.75V15.25c0,.965,.785,1.75,1.75,1.75h6.5c.965,0,1.75-.785,1.75-1.75V2.75c0-.965-.785-1.75-1.75-1.75Zm.25,3V13H5.5V4h7Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconPhoneModernFill18.js.map